import { type MaintenanceChecklistField } from '@gb-ticket/shared-types';

import { maintenanceChecklistFieldViewRegistry } from '@/products/maintenance/features/protocol-renderer/checklist-field-registry';

type Props = {
  field: MaintenanceChecklistField;
  readOnly?: boolean;
};

export function ChecklistFieldView({ field, readOnly = true }: Props) {
  const View = maintenanceChecklistFieldViewRegistry[field.type];
  return <View field={field} readOnly={readOnly} />;
}
